'use strict';

var assign = require('object-assign');

var logger	= require('../../utils/logger.js');

var FluxChangeStore	= require('./flux-change-store.js');
var FluxConstants 	= require('../constants/flux-constants.js');
var FluxDispatcher 	= require('../dispatchers/flux-dispatcher.js');
var Constants 		= require('../constants/equipment-search-constants.js');

var ActionTypes 	= Constants.ActionTypes;
var PayloadSources 	= FluxConstants.PayloadSources;

var storeData = {
	baseSearchContext: null,
	isLoading: true,
	makeItems: [],
	rangeItems: [],
	magazineRatingItems: null,
	minPrice: null,
	maxPrice: null,
	navigatedMake: null,
	navigatedRange: null,
	navigatedMagazineRating: null,
	searchContext: null,
	searchResultsUrl: null,
	searchTerm: null,
	sortOptions: [
	{"Alphabetical (A-Z)": "heading-text-asc"},
	{"Alphabetical (Z-A)": "heading-text-desc"},
	{"Price (high-low)": "price-desc"},
	{"Price (low-high)": "price-asc"},
	{"TG rating (high-low)": "magazine-rating-desc"},
	{"TG rating (low-high)": "magazine-rating-asc"},
	{"Owners rating (high-low)": "user-rating-desc"},
	{"Owners rating (low-high)": "user-rating-asc"}
	],
	totalResults: 0,
	validationErrors: null,
	pricePoints: ["20","40","60","70","100","200","300","400","500","1000"]
};

var store = assign(new FluxChangeStore(), {
	getState: function () {
		return storeData;
	}
});

function handleServerAction(action) {
	if (action) {
		var handled = false;

		switch(action.type) {
			case ActionTypes.EQUIPMENT_SEARCH_LOAD_DATA_SUCCESS:
				handled = true;
				storeData = assign({}, action.data, {
					isLoading: false
				});

				break;
			case ActionTypes.EQUIPMENT_SEARCH_LOAD_DATA_ERROR:
				handled = true;
				storeData.isLoading = false;
				// TODO: render error message

				break;
			default:
				// do nothing
		}

		if (handled) {
			logger.debug({
				store: 'Equipment Search',
				message: 'Handle server action',
				action: action.type,
				data: action.data
			});

			store.emitChange();
		}
	}
}

function handleViewAction(action) {
	if (action) {
		var handled = false;

		switch(action.type) {
			case ActionTypes.EQUIPMENT_SEARCH_UPDATE_FILTERS:
				handled = true;
				storeData.isLoading = true;

				break;
			default:
				// do nothing
		}

		if (handled) {
			logger.debug({
				store: 'Equipment Search',
				message: 'Handle view action',
				action: action.type,
				data: action.data
			});

			store.emitChange();
		}
	}
}

store.dispatchToken = FluxDispatcher.register(function (payload) {
	if (payload && payload.source) {
		if (payload.source === PayloadSources.SERVER_ACTION) {
			handleServerAction(payload.action);
		} else if (payload.source === PayloadSources.VIEW_ACTION) {
			handleViewAction(payload.action);
		}
	}
});

module.exports = store;